import {useEffect, Fragment, useState} from 'react'
import {fromJS} from 'immutable'
import PropTypes from 'prop-types'

import SessionStore from '../../stores/SessionStore'
import PageTitle from '../../../../shared_components/PageTitle'
import CodeVerification from './CodeVerification'

import {findResourceByAttributeId} from '../../../../lib/plan_data/userData'
import preAuthHook from '../../lib/preAuthHook'
import {dasherize} from '../../../../lib/integrationTools'
import SignInActions from '../../actions/SignInActions'
import {useNotificationContext} from '../../../../shared_components/notifications/NotificationContext'

const TfaPrimarySignIn = props => {
  const [error, setError] = useState(SessionStore.getState().signInError)
  const [loading, setLoading] = useState(false)
  const [trustMe, setTrustMe] = useState(false)
  const {alwaysNotify} = useNotificationContext()
  const session = SessionStore.getState()
  const tfaEnrollments = fromJS(session.enrollments?.map(enrollment => dasherize(enrollment)) || [])
  const primaryTfaEnrollment = findResourceByAttributeId({resourceList: tfaEnrollments, attribute: 'category', id: 'primary'})

  const onUpdate = () => {
    const signInError = SessionStore.getState().signInError

    setError(signInError)
    if (signInError) setLoading(false)
  }

  useEffect(() => {
    preAuthHook()
    setError(null)
    SessionStore.addChangeListener(onUpdate)
    return () => {
      SessionStore.removeChangeListener(onUpdate)
    }
  }, [])

  const verifyCode = formData => {
    const primaryEnrollment = SessionStore.getState().primaryEnrollment
    const authenticationMethod = primaryEnrollment?.mode === 'app' ? 'authenticator_app' : `primary_phone_${SessionStore.getState().primaryPhone.preferred_message_mode}`

    setError(null)
    setLoading(true)
    SignInActions.signInWithCode({
      ...formData,
      email: SessionStore.getState().preAuthEmail,
      password: SessionStore.getState().preAuthPassword,
      enrollmentId: primaryEnrollment?.id,
      phoneId: primaryEnrollment?.mode === 'phone' ? session.primaryPhone?.id : null,
      trustMe,
      authenticationMethod
    })

    setTimeout(() => {
      setError(null)
    }, 2000)
  }

  const resendCode = event => {
    if (event) event.preventDefault()

    const email = SessionStore.getState().preAuthEmail
    const password = SessionStore.getState().preAuthPassword
    const signInError = SessionStore.getState().signInError

    SignInActions.signIn(email, password)

    if (SessionStore.getObfuscatedPrimaryNumber() || !signInError)
      alwaysNotify.shortSuccess(SessionStore.getObfuscatedPrimaryNumber() ? `Resent code to ${SessionStore.getObfuscatedPrimaryNumber()}.` : 'Resent code.')
    else
      alwaysNotify.shortError(signInError || 'Unable to resend code.')
  }

  const toggleTrustMe = () => setTrustMe(!trustMe)

  return (
    <Fragment>
      <PageTitle title='Two-Factor Authentication' />
      <CodeVerification
        error={error}
        loading={loading}
        trustMe={trustMe}
        logMixpanelEvent={props.logMixpanelEvent}
        toggleTrustMe={toggleTrustMe}
        tfaEnrollment={primaryTfaEnrollment}
        verifyCode={verifyCode}
        resendCode={resendCode}
        obfuscatedPhoneNumber={SessionStore.getObfuscatedPrimaryNumber()}
      />
    </Fragment>
  )
}

TfaPrimarySignIn.propTypes = {
  logMixpanelEvent: PropTypes.func.isRequired
}

export default TfaPrimarySignIn
